module.exports = __webpack_public_path__ + "static/media/background02.b2f90f08.jpg";